<template>
  <div>
    <van-divider
      :style="{ fontSize: '17px', marginTop: '40px', marginBottom: '10px' }"
    >
      用户协议
    </van-divider>
    <div class="userAgreementContent">
      <div>
        <p>
          甲方：{{
            userAgreementData.fristName || userAgreementData.useridupdatedesc
          }}
        </p>
        <p>
          甲方“众智云擎”账号：{{
            userAgreementData.fristUserId || userAgreementData.useridupdatedesc
          }}
        </p>
        <p>乙方：四川众智云擎科技有限公司</p>
      </div>
      <table
        border="1"
        cellpadding="0"
        cellspacing="0"
        width="100%"
        style="margin-top: 20px"
      >
        <thead>
          <th>产品名称</th>
          <th>产品描述</th>
          <th>产品数量</th>
          <th>服务期限</th>
          <th>服务费用(单位:元)</th>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in userAgreementData.detail"
            :key="index"
            align="center"
          >
            <td>{{ item.productname }}</td>
            <td>{{ item.productdesc }}</td>
            <td>{{ item.number }}</td>
            <td>{{ item.servicedatedesc }}</td>
            <td>{{ item.amount }}</td>
          </tr>
          <tr align="center">
            <td>合计</td>
            <td colspan="4" style="height: 30px">
              {{ sumMoney | toDecimal }}(单位:元)
            </td>
          </tr>
        </tbody>
      </table>
      <h3>通用条款</h3>
      <h4>一、关于服务</h4>
      <div class="contentItemP">
        <p>
          乙方为甲方提供服务的载体为“众智云擎”，网址为http://www.holywiser.com。
        </p>
        <p>
          乙方推荐甲方使用浏览器为：Edge(微软Edge浏览器),Edge(新版),Chrome(谷歌浏览器),
          Firefox(火狐浏览器)
        </p>
        <p>
          乙方为甲方提供税收法规查询及云端工作系统服务，服务内容以“众智云擎”呈现的内容为限。
        </p>
        <!-- <p>
              甲方以账号登录方式使用乙方服务，账号为甲方唯一身份标识且不得更改。
            </p> -->
      </div>
      <h4>二、账号等级差异</h4>
      <div class="contentItemP">
        <p>
          账号等级分为基础版、专业版，具体服务内容以在线商城列示为准。
        </p>
      </div>
      <h4>三、账号续费</h4>
      <div class="contentItemP">
        <p>
          账号有效期内、服务期届满前，可随时续费。
        </p>
        <p>
          服务期届满未续费的，自服务期届满次日起（含次日）账号予以冻结（可以登录，但无法使用功能）；冻结期内账号可以续费，续费当日即可正常使用，续费次日开始计算新的服务期。
        </p>
        <p>
          账号有效期内、服务期届满前，基础版用户可在剩余服务期内升级为专业版用户，但需补足服务费差额。
        </p>
      </div>
      <h4>四、知识产权</h4>
      <div class="contentItemP">
        <p>
          乙方享有“众智云擎”完整的知识产权（包括但不限于发明、外观、软著、商标等），甲方充分尊重并保证不得以任何方式损害乙方知识产权及相关权益。
        </p>
      </div>
      <h4>五、信息条款</h4>
      <div class="contentItemP">
        <p>双方充分信任并保证不滥用服务过程中知悉的数据信息。</p>
      </div>
      <h4>六、权利义务</h4>
      <div class="contentItemP">
        <h5>（一）甲方权利与义务</h5>
        <p>1.甲方有权获取约定服务；</p>
        <p>2.甲方应及时足额支付服务费；</p>
        <p>
          3.甲方不以爬虫等工具大量下载乙方法规数据库、不得允许第三人使用其账号或者以其他不正当方式使用乙方服务。
        </p>
        <h5>（二）乙方权利与义务</h5>
        <p>1.乙方有权收取约定服务费用；</p>
        <p>2.乙方应及时更新税收法规数据库；</p>
        <p>3.因乙方原因造成服务中断的，相应延长服务期限。</p>
      </div>
      <h4>七、款项支付及发票开具</h4>
      <div class="contentItemP">
        <h5>（一）款项支付</h5>
        <p>甲方可选择微信或者支付宝完成支付。</p>
        <h5>（二）发票开具</h5>
        <p>
          甲方应依法选择发票种类（专/普票），在完成支付前通过在线商城界面输入开票信息并保证信息真实合法。
        </p>
      </div>
      <h4>八、违约责任</h4>
      <div class="contentItemP">
        <h5>
          （一）任何一方违约，守约方均可通知违约方，违约方应立即终止违约行为并采取补救措施；
        </h5>
        <h5>
          （二）因乙方原因中断服务的，乙方相应延长服务期；若因乙方原因中断服务满30日仍不能恢复服务的，甲方有权解除协议并要求乙方返还自中断服务之日起至服务期限届满止的服务费，若在此期间乙方恢复服务，甲方账号登录使用，则视为甲方放弃解除权，乙方相应延长服务期。
        </h5>
        <h5>
          （三）违约方应在终止违约行为的同时向守约方支付本协议项下服务费20%的违约金，该违约金的支付不免除任何其他侵权责任。
        </h5>
      </div>
      <h4>九、免责条款</h4>
      <div class="contentItemP">
        <p>
          基于互联网和计算机技术的现状（包括但不限于网络传输技术、信息源、代码技术、程序技术、文字识别处理技术等）及可能引发的技术缺陷与瑕疵的理解与认同，甲方认可并接受下述情形：
        </p>
        <h5>
          （一）“众智云擎”是基于互联网提供服务的，因此，基于网络运营商的原因，可能造成甲方访问速率下降。
        </h5>
        <h5>
          （二）由于配合政府相关部门的工作，可能造成甲方无法访问“众智云擎”。
        </h5>
        <h5>
          （三）因自然原因或者政治因素等不可抗力的原因，甲方可能无法访问使用“众智云擎”，在不可抗力原因消除后，乙方需尽快修复系统并相应延长服务期。
        </h5>
        <h5>
          （四）乙方在其能力所及之范围内尽力保护甲方使用“众智云擎”过程中的计算机安全，但由于互联网的开放性、风险性以及技术缺陷，甲方在使用“众智云擎”的过程中，依然存在可能遭受第三方计算机病毒、恶意软件、恶意程序、恶意代码等侵害的风险。
        </h5>
        <h5>
          （五）“众智云擎”的信息服务内容来源于互联网，通过底层架构、逻辑结构的设计，经计算机技术与人工共同筛选、判断、复核，
          尽量确保信息的准确、完整、及时，但基于技术与人力的现状，仍无法对信息内容的完整性与准确性做出绝对性承诺，任何正式使用乙方税收法规库的情形，仍需与官方文本比对。
        </h5>
        <h5>
          （六）“众智云擎”的信息服务内容来源于互联网，不代表乙方及其任何关联方的意见，也不构成乙方及其任何关联方的建议。
        </h5>
        <p>
          因上述情形，乙方及其任何关联方不承担甲方任何直接或者间接损失，甲方表示接受与理解。
        </p>
      </div>
      <h4>十、争议解决</h4>
      <div class="contentItemP">
        <p>双方同意如下争议解决方式：</p>
        <h5>（一）首先由双方协商解决；</h5>
        <h5>
          （二）无法协商的，鉴于乙方提供互联网信息服务，由乙方所在地法院诉讼解决。
        </h5>
      </div>
      <h4>十一、其他</h4>
      <div class="contentItemP">
        <h5>
          （一）甲方确认支付，即视为同意并签订本协议；当日支付，次日计算服务期；
        </h5>
        <h5>（二）未尽事宜，双方协商一致，可签订补充协议；</h5>
        <h5>（三）本协议以电子文本形式存在，具有法律效力；</h5>
        <h5>
          （四）甲方可点击账号下的“账号中心”，查阅、打印协议；甲方应自支付完成之日起90日内通过“账号中心”再次确认发票信息并开具发票（超过90日未再次确认的，系统将按照甲方支付时确认的开票信息自动开具发票），发票开具后可查阅、打印。
        </h5>
      </div>
      <div class="contentItemP marginT zhangStyle">
        <p>
          甲方：{{
            userAgreementData.fristName || userAgreementData.useridupdatedesc
          }}
        </p>
        <p>
          甲方“众智云擎”账号：{{
            userAgreementData.fristUserId || userAgreementData.useridupdatedesc
          }}
        </p>
        <p style="margin-top: 20px">乙方：四川众智云擎科技有限公司</p>
        <p>签订时间：</p>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["userAgreementData", "sumMoney"],
};
</script>

<style lang="less" scoped>
// 协议
.userAgreementContent {
  padding: 0 10px;
  margin-bottom: 3rem;
  line-height: 24px;
  & > h4 {
    margin-bottom: 0;
  }
  .contentItemP {
    & > p {
      text-indent: 20px;
      margin: 0;
      margin-top: 4px;
    }
    & > h5 {
      margin: 0;
      margin-top: 4px;
    }
  }
  .marginT {
    margin-top: 20px;
  }
  .zhangStyle {
    position: relative;
    & > img {
      position: absolute;
      top: 42%;
      left: 28%;
    }
  }
}
</style>
